/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Ref_IntroInputs */

const en_csv_to_json_ref_intro = /** @type {(inputs: Csv_To_Json_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each row is a real CSV fragment and the value this tool produces from it.`)
};

const ko_csv_to_json_ref_intro = /** @type {(inputs: Csv_To_Json_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각 행은 실제 CSV 조각과 이 도구가 그것으로부터 만드는 값입니다.`)
};

const ja_csv_to_json_ref_intro = /** @type {(inputs: Csv_To_Json_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各行は実際の CSV の断片と、このツールがそこから作る値です。`)
};

/**
* | output |
* | --- |
* | "Each row is a real CSV fragment and the value this tool produces from it." |
*
* @param {Csv_To_Json_Ref_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_ref_intro = /** @type {((inputs?: Csv_To_Json_Ref_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Ref_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_ref_intro(inputs)
	if (locale === "ko") return ko_csv_to_json_ref_intro(inputs)
	return ja_csv_to_json_ref_intro(inputs)
});